/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// pages
import EditEmbedName from 'pages/dashboard/embeds/management/editembedname/editembedname_container';
// material
import { Icon } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embedname/embedname_styles';



/* ========== ~~~~~~~~~~ EMBED NAME ~~~~~~~~~~ ========== */
const EmbedName = (props) => {
	const handleClick = (e) => {
		props.displayModal(true, <EditEmbedName createEmbed={false} updateEmbed={props.handleSaveEmbed} />)
	};
	return (
		<div className={`embedname ${props.classes.embedname}`} onClick={handleClick}>
			<span className={'name'}>{props.embedName ? props.embedName : 'Embed Name'}</span>
			/
			<span className={'site'}>{props.siteURL ? props.siteURL : 'http://site.com'}</span>
			<Icon name={`edit`} />
		</div>
	);
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EmbedName);
